import React from "react";
import PropTypes from "prop-types";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "@sainsburys-tech/fable";
import LastUpdate from "../LastUpdate";
import formatSensorValue from "../../model/sensors/formatSensorValue";

const SensorList = props => {
  return (
    <Table isResponsive={true} layout="fixed">
      <TableHeader style={{ display: 'none' }}>
        <TableRow>
          <TableHeaderCell>Sensor</TableHeaderCell>
          <TableHeaderCell>Value</TableHeaderCell>
          <TableHeaderCell>Last update</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.sensors.map((sensor, index) => (
          <TableRow key={index}>
            <TableCell>{sensor.name}</TableCell>
            <TableCell>
              {formatSensorValue(
                sensor.lastValue ? sensor.lastValue.value : null,
                sensor.unit.description
              )}
            </TableCell>
            <TableCell>
              {(sensor.lastValue && sensor.lastValue.time && (
                <LastUpdate>{sensor.lastValue.time}</LastUpdate>
              )) ||
              "Awaiting value..."}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

SensorList.propTypes = {
  sensors: PropTypes.array.isRequired
};

export default SensorList;
